import React, {FC} from 'react';

interface Props {
}

const Terms: FC<Props> = () => {
  return (
    <main className='terms-page'>
      <div className="container">
        <div className="docs_wrap container">
          <h2>Terms of use</h2>
          <div className="docs_updated">
            <span>Effective Date. June 01, 2022</span>
          </div>
          <div className="docs_content">
            <p>Definitions. “Attitune Lab” means a Florida corporation with its address 2501 S Ocean drive apt 624
              Hollywood
              Florida 33019. “Attitune Lab Content” means content owned or licensed by Attitune Lab. “Attitune Lab
              Parties”
              means Attitune Lab together with its employees, managers, officers or agents. “Service” means the Attitune
              Lab
              service, or any applications (including mobile applications) made available by Attitune Lab. “Terms of
              Use”
              means these terms of use, as they may be amended from time to time by Attitune Lab in its discretion
              pursuant
              to the terms hereof. “You” means you, the user of the Service. “Your Content” means any images, graphics,
              photos, audio and video clips, sounds, and other content or materials that you create on, upload to, or
              processing using the Service.
            </p>
            <p>Service Age Restriction. You must be at least 18 years old to use the Service.
            </p>
            <p>Your Obligations. If you use the Service, you agree to do each of the following: (a) comply with all
              laws,
              rules and regulations (for example, federal, state, local and provincial) applicable to your use of the
              Service and Your Content, including but not limited to, copyright laws; and (b) be fully responsible for
              your
              conduct and Your Content on the Service.
            </p>
            <p>Restrictions on Use. You may not engage in any of the following in connection with your use of the
              Service:
              (a) use the Service for any illegal or unauthorized purpose; (b) use Attitune Lab Content in combination
              with
              Your Content in a pornographic, defamatory, or deceptive context, or in a manner that could be considered
              libelous, obscene, or illegal; (c) portray any person depicted in Attitune Lab Content in a way that a
              reasonable person would find offensive, including but not limited to (i) in connection with pornography,
              adult
              videos, adult entertainment venues, escort services or the like, or (ii) engaging in immoral or criminal
              activities; (d) use the Service for commercial purposes; (e) infringe upon any third party’s trademark or
              other intellectual property right, or give rise to a claim of deceptive advertising or unfair competition;
              (f)
              interfere with or disrupt the Service or servers or networks connected to the Service, including by
              transmitting any worms, viruses, spyware, malware or any other code of a destructive or disruptive nature;
              (g)
              inject content or code or otherwise alter or interfere with the way any Attitune Lab page is rendered or
              displayed in a user’s browser or on a user’s device; or (h) access or collect data from our Service using
              automated means or attempt to access data you do not have permission to access.
            </p>
            <p>Payment terms. Attitune Lab may offer products and services for purchase on the App (“In-App Purchase”).
              If
              you choose to make an In-App Purchase, you acknowledge and agree that additional terms, disclosed to you
              at
              the point of purchase, may apply, and that such additional terms are incorporated herein by reference.
            </p>
            <p>You may make an In-App Purchase through the following payment methods (“Payment Method”): (a) making a
              purchase through a third-party platform such as the Apple App Store and Google Play Store (“Third Party
              Store”).
            </p>
            <p>Subscriptions and Auto-Renewal: Attitune Lab may offer some services as automatically-renewing
              subscriptions,
              e.g., a one-month subscription, six-month subscription or one-year subscription etc. (“Premium Services”).
              IF
              YOU PURCHASE AN AUTOMATICALLY RENEWING SUBSCRIPTION, YOUR SUBSCRIPTION WILL RENEW AT THE END OF THE
              PERIOD,
              UNLESS YOU CANCEL, AT Attitune Lab’S THEN-CURRENT PRICE FOR SUCH SUBSCRIPTIONS. To avoid charges for a new
              subscription period, you must cancel, as described below, before the end of the then-current subscription
              period. Deleting your account or deleting the application from your device does not cancel your
              subscription.
              You will be given notice of changes in the pricing of the Premium Services to which you have subscribed
              and an
              opportunity to cancel. If Attitune Lab changes these prices and you do not cancel your subscription, you
              agree
              that you will be charged at Attitune Lab’s then-current pricing for subscription.
            </p>
            <p>Canceling Subscriptions. If you purchased a subscription through a Third Party Store, such as the Apple
              App
              Store or the Google Play Store, you will need to access your account with that Third Party Store and
              follow
              instructions to change or cancel your subscription. If you cancel your subscription, you may use your
              subscription until the end of the period you last paid for, but (i) you will not (except as set forth in
              the
              subsection entitled “Refunds” below) be eligible for a prorated refund, (ii) your subscription will not be
              renewed when that period expires and (iii) you will then no longer be able to use the Premium Services or
              In-App Purchases enabled by your subscription.
            </p>
            <p>Refunds. Generally, all charges for purchases are nonrefundable, and there are no refunds or credits for
              partially used periods.
            </p>
            <p>For subscribers residing in Arizona, California, Connecticut, Illinois, Iowa, Minnesota, New York, North
              Carolina, Ohio, Rhode Island, and Wisconsin, the terms below apply:
            </p>
            <p>You may cancel your subscription, without penalty or obligation, at any time prior to midnight of the
              third
              business day following the date you subscribed. In the event that you die before the end of your
              subscription
              period, your estate shall be entitled to a refund of that portion of any payment you had made for your
              subscription which is allocable to the period after your death. In the event that you become disabled
              (such
              that you are unable to use Attitune Lab) before the end of your subscription period, you shall be entitled
              to
              a refund of that portion of any payment you had made for your subscription which is allocable to the
              period
              after your disability by providing the company notice in the same manner as you request a refund as
              described
              below.
            </p>
            <p>To request a refund:
            </p>
            <p>In addition to canceling, you must request a refund to receive one. If you subscribed using your Apple
              ID,
              refunds are handled by Apple, not Attitune Lab. To request a refund, go to iTunes, click on your Apple ID,
              select “Purchase history,” find the transaction and hit “Report Problem”. You can also submit a request at
              https://getsupport.apple.com.
            </p>
            <p>For all other purchases: please contact <a href="mailto:info@attitune.com">info@attitune.com</a>. You may
              also mail or deliver a signed and dated notice which states that you, the buyer, are canceling this
              agreement,
              or words of similar effect. Please also include the email address or mobile number associated with your
              account along. This notice shall be sent to: Attitune Lab 2501 S Ocean drive unit 624 Hollywood Florida
              33019.
            </p>
            <p>Taxes. The payments required under this section do not include any Sales Tax that may be due in
              connection
              with the Premium Services provided under these Terms. If Attitune Lab determines it has a legal obligation
              to
              collect a Sales Tax from you in connection with these Terms, Attitune Lab will collect such Sales Tax in
              addition to the payments required under this section. If any Premium Services, or payments for any Premium
              Services, under these Terms are subject to any Sales Tax in any jurisdiction and you have not remitted the
              applicable Sales Tax to Attitune Lab, you will be responsible for the payment of such Sales Tax and any
              related penalties or interest to the relevant tax authority. As used herein, “Sales Tax” means any sales
              or
              use tax and any other tax measured by sales proceeds that is the functional equivalent of a sales tax
              where
              the applicable taxing jurisdiction does not otherwise impose a sales or use tax.
            </p>
            <p>Push notifications; location-based features. We may provide you with emails, text messages, push
              notifications, alerts and other messages related to the App and/or the Attitune Lab services, such as
              enhancements, offers, products, events, and other promotions. After downloading the App, you will be asked
              to
              accept or deny push notifications/alerts. If you deny, you will not receive any push notifications/alerts.
              If
              you accept, push notifications/alerts will be automatically sent to you. If you no longer wish to receive
              push
              notifications/alerts from the App, you may opt out by changing your notification settings on your mobile
              device. With respect to other types of messaging or communications, such as emails, text messages, etc.,
              you
              can unsubscribe or opt out by either following the specific instructions included in such communications,
              or
              by emailing us with your request at <a href="mailto:info@attitune.com">info@attitune.com</a>.
            </p>
            <p>The App may allow access to or make available opportunities for you to view certain content and receive
              other
              products, services and/or other materials based on your location. To make these opportunities available to
              you, the App will determine your location using one or more reference points, such as GPS, Bluetooth
              and/or
              software within your mobile device. If you have set your mobile device to disable GPS, Bluetooth or other
              location determining software or do not authorize the App to access your location data, you will not be
              able
              to access such location-specific content, products, services and materials. For more about how the App
              uses
              and retains your information, please read the
              <a href="/policy">Privacy Policy</a>.
            </p>
            <p>Service Interruptions and Availability. There may be occasions when the Service will be interrupted or
              unavailable, including, without limitation, for scheduled maintenance or upgrades, for emergency repairs,
              or
              due to failure of telecommunications links and/or equipment. Attitune Lab shall have no liability for any
              such
              interruptions.
            </p>
            <p>Termination or Modification of Service. Attitune Lab reserves the right, in its sole discretion, to
              modify or
              terminate the Service, or your access to the Service, for any reason, without notice, at any time, and to
              refuse access to the Service to anyone for any reason at any time. If Attitune Lab terminates your access
              to
              the Service, Your Content will no longer be accessible to you. Upon termination, all licenses and other
              rights
              granted to you in these Terms of Use will immediately cease. Attitune Lab will not be liable to you for
              any
              modification, suspension, or discontinuation of the Service, or for the loss of Your Content.
            </p>
            <p>Territorial Restrictions. Attitune Lab reserves the right to limit the availability or scope of the
              Service
              or any portion of the Service, to any person, geographic area, or jurisdiction, at any time and in its
              sole
              discretion.
            </p>
            <p>Intellectual Property Ownership of Your Content. Attitune Lab does not claim ownership of Your Content
              that
              you upload to or analyse through the Service.
            </p>
            <p>Royalty- Free License. You hereby grant to Attitune Lab a non-exclusive, fully paid and royalty-free,
              transferable, sub-licensable, worldwide license to use Your Content to provide our Service, subject to the
              Privacy Policy.
            </p>
            <p> Representations and Warranties. You represent and warrant to Attitune Lab that: (a) you own Your Content
              or
              otherwise have the right to grant the rights and licenses set forth in these Terms of Use; (b) you agree
              to
              pay for all royalties, fees, and any other monies owed for Your Content, as stylized through the Service,
              as
              applicable; (c) you are at least 18 years old; (d) you have the legal right and capacity to enter into
              these
              Terms of Use in your jurisdiction; and (e) if you are using the Service on behalf of a legal entity, you
              are
              authorized to enter into an agreement on behalf of that legal entity. Attitune Lab Content. The Service
              contains Attitune Lab Content. Attitune Lab Content is protected by copyright, trademark, patent, trade
              secret
              and other laws, and, as between you and Attitune Lab, Attitune Lab owns and retains all rights in the
              Attitune
              Lab Content and the Service. You will not remove, alter or conceal any copyright, trademark, service mark
              or
              other proprietary rights notices incorporated in or accompanying the Attitune Lab Content and you will not
              reproduce, modify, adapt, prepare derivative works based on, perform, display, publish, distribute,
              transmit,
              broadcast, sell, license or otherwise exploit the Attitune Lab Content.
            </p>
            <p>Third Party Content. You can open all kinds of websites in the background of the application to take a
              screenshot to make for faster photo processing, without pressing additional buttons such as "upload
              photo",
              etc.
            </p>
            <p>You are legally responsible for the Content you submit to the Service. We may use automated systems that
              analyze your Content to help detect infringement and abuse, such as spam, malware, and illegal content.
            </p>
            <p>Attitune Lab Trademarks and Service Marks. The Attitune Lab name and logo are trademarks of Attitune Lab,
              and
              may not be copied, imitated or used, in whole or in part, without the prior written permission of Attitune
              Lab. In addition, all custom graphics and fonts used on the Service are service marks, trademarks and/or
              trade
              dress of Attitune Lab, and may not be copied, imitated or used, in whole or in part, without prior written
              permission from Attitune Lab.</p>
            <p>Removal of Content. Attitune Lab reserves the right to remove Your Content from the Service for any
              reason,
              without prior notice. Content removed from the Service may continue to be stored by Attitune Lab,
              including,
              without limitation, in order to comply with certain legal obligations, but may not be retrievable without
              a
              valid court order. You agree that you will not rely on the Service for the purposes of backup or storage
              of
              Your Content.
            </p>
            <p>Feedback. You are under no obligation to give Attitune Lab any ideas, suggestions, comments or other
              feedback
              related to the Service or the business or operations of Attitune Lab. If you share ideas, suggestions,
              comments, or other feedback with Attitune Lab, Attitune Lab will own such idea, suggestion, comment or
              feedback. You hereby assign all of your right, title, and interest in such idea, suggestion, comment, or
              feedback to Attitune Lab and agree that Attitune Lab will be free to use and implement same, without
              restriction or obligation of any kind, without, however, any obligation to do so.
            </p>
            <p>Third Parties. Attitune Lab does not warrant, endorse, guarantee, or assume responsibility for any
              product or
              service advertised or offered by a third party through the Service or any hyperlinked website or featured
              in
              any banner or other advertising, and Attitune Lab will not be a party to or in any way be responsible for
              monitoring any transaction between you and third- party providers of products or services. Attitune Lab is
              not
              responsible for the actions, content, information, or data of third parties, and you release the Attitune
              Lab
              Parties from any claims and damages, known and unknown, arising out of or in any way connected with any
              claim
              you have or may have against any such third parties.
            </p>
            <p>Disclaimer of Warranties. The Service, including, without limitation, Attitune Lab Content, is provided
              on an
              “as is”, “as available” and “with all faults” basis. To the fullest extent permissible by law, Attitune
              Lab
              makes no representations or warranties or endorsements of any kind whatsoever, express or implied, as to:
              (a)
              the Service; (b) the Attitune Lab Content; (c) Your Content; or (d) security associated with the
              transmission
              of information to Attitune Lab or via the Service. Attitune Lab hereby disclaims all warranties, express
              or
              implied, including, but not limited to, the warranties of merchantability, fitness for a particular
              purpose,
              non-infringement, title, custom, trade, quiet enjoyment, system integration and freedom from computer
              virus.
              Attitune Lab does not represent or warrant that the Service will be error-free or uninterrupted; that
              defects
              will be corrected; or that the Service or the server that makes the Service available is free from any
              harmful
              components, including, without limitation, viruses. Attitune Lab does not make any representations or
              warranties that the information (including any instructions) on the Service is accurate, complete, or
              useful.
              Attitune Lab makes no representations that the Service is appropriate or available for use in all
              locations.
              If you access or use the Service from jurisdictions prohibiting such use, you do so at your own volition
              and
              are responsible for compliance with local law. You acknowledge that your use of the Service is at your
              sole
              risk. Some jurisdictions limit or do not allow the disclaimer of implied or other warranties so the above
              disclaimer may not apply to you to the extent such jurisdiction’s law is applicable to you and these Terms
              of
              Use.
            </p>
            <p>Limitation of Liability; Waiver. Under no circumstances will the Attitune Lab Parties be liable to you
              for
              any loss or damages of any kind (including, without limitation, for any direct, indirect, economic,
              exemplary,
              special, punitive, incidental or consequential losses or damages) that are directly or indirectly related
              to:
              (a) the Service; (b) the Attitune Lab Content; (c) Your Content; (d) your use of, inability to use, or the
              performance of the Service; (e) any action taken in connection with an investigation by the Attitune Lab
              Parties or law enforcement authorities regarding your or any other party’s use of the Service; (f) any
              action
              taken in connection with copyright or other intellectual property rights; (g) any errors or omissions in
              the
              Service’s operation; or (h) any damage to any user’s computer, mobile device, or other equipment or
              technology
              including, without limitation, damage from any security breach or from any virus, bugs, tampering, fraud,
              error, omission, interruption, defect, delay in operation or transmission, computer line or network
              failure or
              any other technical or other malfunction. This limitation of liability includes, without limitation,
              damages
              for lost profits, loss of goodwill, loss of data, work stoppage, accuracy of results, or computer failure
              or
              malfunction, even if foreseeable or even if the Attitune Lab Parties have been advised of or should have
              known
              of the possibility of such damages, whether in an action of contract, negligence, strict liability or tort
              (including, without limitation, whether caused in whole or in part by negligence, acts of God,
              telecommunications failure, or theft or destruction of the Service). In no event will the Attitune Lab
              Parties
              be liable to you or anyone else for loss, damage or injury, including, without limitation, death or
              personal
              injury. Some states do not allow the exclusion or limitation of incidental or consequential damages, so
              the
              above limitation or exclusion may not apply to you. In no event will the Attitune Lab Parties’ total
              liability
              to you for all damages, losses or causes or action exceed One Hundred U.S. Dollars ($100.00). Waiver. By
              accessing the Service, you understand that you may be waiving rights with respect to claims that are at
              this
              time unknown or unsuspected, and in accordance with such waiver, you acknowledge that you have read and
              understand, and hereby expressly waive, the benefits of Section 1542 of the Civil Code of California, and
              any
              similar law of any state or territory, which provides as follows: “A general release does not extend to
              claims
              which the creditor does not know or suspect to exist in his favor at the time of executing the release,
              which
              if known by him must have materially affected his settlement with the debtor.”
            </p>
            <p>Indemnification. You (and also any third party for whom you operate an account or activity on the
              Service)
              agree to defend (at Attitune Lab’s request), indemnify and hold the Attitune Lab Parties harmless from and
              against any claims, liabilities, damages, losses, and expenses, including without limitation, reasonable
              attorneys’ fees and costs, arising out of or in any way connected with any of the following (including as
              a
              result of your direct activities on the Service or those conducted on your behalf): (a) Your Content or
              your
              access to or use of the Service; (b) your breach or alleged breach of these Terms of Use; (c) your
              violation
              of any third-party right, including without limitation, any intellectual property right, publicity,
              confidentiality, property or privacy right; (d) your violation of any laws, rules, regulations, codes,
              statutes, ordinances or orders of any governmental and quasi- governmental authorities, including, without
              limitation, all regulatory, administrative and legislative authorities; or (e) any misrepresentation made
              by
              you. You agree to cooperate as fully required by Attitune Lab in the defense of any claim. Attitune Lab
              reserves the right to assume the exclusive defense and control of any matter subject to indemnification by
              you, and you will not in any event settle any claim without the prior written consent of Attitune Lab.
            </p>
            <p>About these Terms of Use Acceptance. By accessing or using the Service, however accessed, you agree to be
              bound by these Terms of Use. The Service is owned or controlled by Attitune Lab. These Terms of Use affect
              your legal rights and obligations. If you do not agree to be bound by all of these Terms of Use, do not
              access
              or use the Service.
            </p>
            <p>Violation. Violation of these Terms of Use may, in Attitune Lab’s sole discretion, result in a ban of
              Attitune Lab usage. You understand and agree that Attitune Lab cannot and will not be responsible for Your
              Content (defined below) on the Service and you use the Service at your own risk. If you violate the letter
              or
              spirit of these Terms of Use, or otherwise create risk or possible legal exposure for Attitune Lab,
              Attitune
              Lab can stop providing all or any part of the Service to you.
            </p>
            <p>Special Terms. There may be times when Attitune Lab offers a special feature that has its own terms and
              conditions that apply in addition to these Terms of Use. In those cases, the terms specific to the special
              feature control to the extent there is a conflict with these Terms of Use.
            </p>
            <p>Modification of Terms of Use. Attitune Lab reserves the right, in its sole discretion, to change these
              Terms
              of Use (“Updated Terms”) from time to time. Attitune Lab may notify you of the Updated Terms by posting
              them
              on the Service, and your use of the Service after the effective date of the Updated Terms constitutes your
              agreement to the Updated Terms. The Updated Terms will be effective as of the time of posting, or such
              later
              date as may be specified in the Updated Terms, and will apply to your use of the Service from that point
              forward. These Terms of Use will govern any disputes arising before the effective date of the Updated
              Terms.
            </p>
            <p>Dispute Resolution. These Terms of Use are governed by and construed in accordance with the laws of the
              State
              of Florida, without giving effect to any principles of conflicts of law AND WILL SPECIFICALLY NOT BE
              GOVERNED
              BY THE UNITED NATIONS CONVENTIONS ON CONTRACTS FOR THE INTERNATIONAL SALE OF GOODS, IF OTHERWISE
              APPLICABLE.
              You agree to resolve any dispute you have with Attitune Lab exclusively in a state or federal court
              located in
              Florida, and to submit to the personal jurisdiction of the courts located in any other state for the
              purpose
              of litigating all such disputes. You agree that any claim you may have arising out of or related to your
              relationship with Attitune Lab must be filed within one year after such claim arose; otherwise, your claim
              is
              permanently barred.
            </p>
            <p>Entire Agreement. These Terms of Use, together with the Privacy Policy, constitute the entire agreement
              between you and Attitune Lab and govern your use of the Service, superseding any prior agreements between
              you
              and Attitune Lab.
            </p>
            <p>Assignment. You will not assign the Terms of Use or assign any rights or delegate any obligations
              hereunder,
              in whole or in part, whether voluntarily or by operation of law, without the prior written consent of
              Attitune
              Lab. Any purported assignment or delegation by you without the appropriate prior written consent of
              Attitune
              Lab will be null and void. Attitune Lab may assign these Terms of Use or any rights hereunder without your
              consent.
            </p>
            <p>Severability. If any provision of these Terms of Use is found by a court of competent jurisdiction to be
              invalid or otherwise unenforceable, the parties nevertheless agree that such portion will be deemed
              severable
              from these Terms of Use and will not affect the validity and enforceability of the remaining provisions,
              and
              the remaining provisions of the Terms of Use remain in full force and effect.
            </p>
            <p>No Waiver. Attitune Lab’s failure to insist upon or enforce strict performance of any provision of these
              Terms of Use will not be construed as a waiver of any provision or right. No waiver of any term of these
              Terms
              of Use will be deemed a further or continuing waiver of such term or condition or any other term or
              condition.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Terms;